import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import axios from "axios";
import { makeStyles } from "@material-ui/styles";
import {
  FormLabel,
  ModalError,
  ModalSuccess,
  PrimaryButton,
  SecondaryButton,
  TextInput,
} from "components";
import { useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { getErrors } from "utils";

const useStyles = makeStyles(theme => ({
  paper: {
    borderRadius: 12,
    padding: theme?.spacing ? theme.spacing(1) : 8,
  },
  dialogContent: {
    paddingTop: theme?.spacing ? theme.spacing(1) : 8,
    paddingBottom: theme?.spacing ? theme.spacing(2) : 16,
  },
}));

const ModalCancelPotentialClaim = ({
  open,
  onClose,
  dataItem,
  onSuccess,
}) => {
  const classes = useStyles();
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  const documentNumber = dataItem?.document_number || dataItem?.doc_no || "";

  const handleClose = () => {
    setReason("");
    onClose();
  };

  const handleConfirmCancel = async () => {
    if (!reason.trim()) return;
    setLoading(true);
    try {
      const res = await axios.post(
        `${hardBaseUrl}/admin/potential-claim/claim-logs/${dataItem?.id}/cancel`,
        { reason: reason.trim() },
        { headers }
      );

      ModalSuccess(
        res?.data?.message || "Successfully Canceled Potential Claim"
      ).then(() => {
        handleClose();
        if (onSuccess) onSuccess();
      });
    } catch (error) {
      ModalError(getErrors(error?.response || error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        classes: { root: classes.paper },
      }}
    >
      <DialogTitle>
        <Typography variant="h6" fontWeight={700} color="#111827">
          Cancel Potential Claim
        </Typography>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormLabel label="Document Number" />
            <TextInput
              value={documentNumber}
              disabled
              width="100%"
            />
          </Grid>
          <Grid item xs={12}>
            <FormLabel label="Reason" required />
            <TextInput
              placeholder="Reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              multiline
              rows={4}
              width="100%"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: 2, justifyContent: "flex-end", gap: 1 }}>
        <SecondaryButton
          label="Cancel"
          onClick={handleClose}
          disabled={loading}
        />
        <PrimaryButton
          label="Confirm Cancel"
          onClick={handleConfirmCancel}
          disabled={!reason.trim() || loading}
          loading={loading}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalCancelPotentialClaim;
